import { render } from "preact";
import { registerSW } from "virtual:pwa-register";
import { defaultConfig } from "./engine/config";
import { isoDateTime } from "./engine/dates";
import { DashboardViewModel } from "./app/dashboardViewModel";
import { workerRunner } from "./app/workerRunner";
import { IdbRepositories } from "./storage/idb";
import { App } from "./ui/App";
import { updateAvailable } from "./ui/updatePrompt";
import "./styles.css";

/** Local wall-clock time as fixed-width ISO (the engine only ever looks at the date part). */
function nowIso(): string {
  const d = new Date();
  const date = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  return isoDateTime(date, d.getHours(), d.getMinutes(), d.getSeconds());
}

async function boot(): Promise<void> {
  const repos = await IdbRepositories.open();
  const vm = new DashboardViewModel({ repos, config: defaultConfig(), now: nowIso });
  await vm.load();

  const applyUpdate = registerSW({
    onNeedRefresh() { updateAvailable.value = () => void applyUpdate(true); },
  });

  const root = document.getElementById("app");
  if (root) render(<App vm={vm} repos={repos} />, root);

  // Automatic tuning, once it is due: after first paint, off the main thread, never blocking or failing the app.
  const idle = (cb: () => void) => ("requestIdleCallback" in window ? window.requestIdleCallback(cb, { timeout: 5000 }) : setTimeout(cb, 1500));
  idle(() => void vm.autoTuneIfDue(workerRunner));
}

void boot().catch((e: unknown) => {
  const root = document.getElementById("app");
  if (root) root.textContent = `Puck Tech could not start: ${e instanceof Error ? e.message : String(e)}`;
});
